const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.84074 38.54852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.50046,21.90257v-.7581a.38468.38468,0,0,0-.251-.3594c-1.7728-.6654-3.7407-1.4918-3.9061-2.0068v-.5401a3.39185,3.39185,0,0,0,.8294-1.4719.85944.85944,0,0,0,.1736-1.2692v-1.2092c0-1.2483-.7156-2.1028-2.3515-2.1028-1.5937,0-2.3523.8545-2.3523,2.1028v1.2097a.85991.85991,0,0,0,.1736,1.2685,3.38913,3.38913,0,0,0,.8299,1.4721v.5401c-.165.5144-2.1334,1.341-3.9061,2.0068a.38518.38518,0,0,0-.2511.3594v.7581",
    style: {
      fill: "none",
      stroke: "#007dc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.40206,2.18447h-2.8147a.949.949,0,0,0-.9395,1.0039l.5614,5.1765a.89432.89432,0,0,0,.9395.715h1.6915a.88592.88592,0,0,0,.9395-.7038l.5618-5.2056A.94648.94648,0,0,0,19.40206,2.18447Z",
    style: {
      fill: "none",
      stroke: "#007dc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.96886,8.20007h-2.0638a2.27171,2.27171,0,0,0-2.3338,2.1804V30.03a2.16259,2.16259,0,0,0,2.3338,2.0426h14.1794a2.16247,2.16247,0,0,0,2.3336-2.0426V10.38047a2.27159,2.27159,0,0,0-2.3336-2.1804h-2.064",
    style: {
      fill: "none",
      stroke: "#007dc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.75756,
    y1: 28.25976,
    x2: 23.50046,
    y2: 28.25976,
    style: {
      fill: "none",
      stroke: "#007dc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.48886,
    y1: 28.25976,
    x2: 14.99636,
    y2: 28.25976,
    style: {
      fill: "none",
      stroke: "#007dc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.59166,
    y1: 24.13247,
    x2: 27.39766,
    y2: 24.13247,
    style: {
      fill: "none",
      stroke: "#007dc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.99466,
    y1: 5.71917,
    x2: 17.99466,
    y2: 5.71917,
    style: {
      fill: "none",
      stroke: "#007dc3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.78bb71e0048fda885e49bb086d661bbc.svg";
export { ForwardRef as ReactComponent };